// extracted by mini-css-extract-plugin
export var LayoutInfoModal = "styles-module--LayoutInfoModal--1gYwf";
export var Image = "styles-module--Image--QeXm0";
export var Image_Container = "styles-module--Image_Container--v2raI";
export var CloseButton = "styles-module--CloseButton--26tCE";
export var Body_Container = "styles-module--Body_Container--3MMi1";
export var Description_Container = "styles-module--Description_Container--2El4x";